import type { GetResourceTypesInput, ResourceTypeCreateDto, ResourceTypeDto, ResourceTypeUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResourceTypeService {
  apiName = 'Analysis';

  create = (input: ResourceTypeCreateDto) =>
    this.restService.request<any, ResourceTypeDto>({
      method: 'POST',
      url: `/api/analysis/resource-types`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/analysis/resource-types/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, ResourceTypeDto>({
      method: 'GET',
      url: `/api/analysis/resource-types/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetResourceTypesInput) =>
    this.restService.request<any, PagedResultDto<ResourceTypeDto>>({
      method: 'GET',
      url: `/api/analysis/resource-types`,
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: ResourceTypeUpdateDto) =>
    this.restService.request<any, ResourceTypeDto>({
      method: 'PUT',
      url: `/api/analysis/resource-types/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
